import React, { useState } from "react";
import {
  useClearRefinements,
  useCurrentRefinements,
  useRefinementList,
} from "react-instantsearch-hooks-web";

function BedMobileRefinement() {
  const currentProps = useCurrentRefinements();
  const currentItems = currentProps.items;
  const refineCurrent = currentProps.refine;
  const {
    items,
    hasExhaustiveItems,
    createURL,
    refine,
    sendEvent,
    searchForItems,

    isFromSearch,
    canRefine,
    canToggleShowMore,
    isShowingMore,
    toggleShowMore,
  } = useRefinementList({ attribute: "noOfBedrooms", sortBy: ["name:asc"] });

  const propBaths = useRefinementList({
    attribute: "noOfBathrooms",
    sortBy: ["name:asc"],
  });
  const propBathsItems = propBaths.items;
  const propBathsRefine = propBaths.refine;

  const [open, setOpen] = useState(false);
  //

  //bathrooms
  const currentPropsBath = useCurrentRefinements();
  const currentItemsBath = currentPropsBath.items;
  const refineCurrentBath = currentPropsBath.refine;
  // end bath

  const arr = currentItems.find((c) => c.attribute === "noOfBedrooms");

  const arrBath = currentItemsBath.find((c) => c.attribute === "noOfBathrooms");
  // console.log(arr);

  const clearBds = useClearRefinements({
    includedAttributes: ["noOfBedrooms"],
  });
  const clearBaths = useClearRefinements({
    includedAttributes: ["noOfBathrooms"],
  });
  return (
    <div className=" grid grid-flow-col">
      <div
        onClick={() => {
          clearBds.refine();
        }}
        className={
          " flex flex-shrink-0 cursor-pointer items-center justify-center rounded-l-md border   px-5 py-2 font-semibold  " +
          (arr === undefined
            ? "text-ula-secondary border-ula-blue bg-blue-50"
            : "  border-gray-300")
        }
      >
        Any
      </div>

      {items?.map((item, index) => {
        const exists =
          arr?.refinements.find((el) => el.value === item.value)?.value !=
          undefined;
        if (item.value === "0") {
          return (
            <div
              onClick={() => {
                refineCurrent(item.value);
                refine(item.value);
              }}
              key={item.value}
              className={
                (exists
                  ? " text-ula-secondary border border-ula-blue bg-blue-100 "
                  : "") +
                "  flex flex-shrink-0 cursor-pointer items-center   justify-center border   px-5 py-2 font-semibold text-gray-900" +
                (index === items.length - 1
                  ? " rounded-r-md border border-gray-300 "
                  : " border-b border-l-0 border-r-0 border-t  border-gray-300 ")
              }
            >
              Studio
            </div>
          );
        }
        return (
          <div
            key={item.value}
            onClick={() => {
              refineCurrent(item.value);
              refine(item.value);
            }}
            className={
              "  flex flex-shrink-0 cursor-pointer items-center justify-center border      px-5 py-2 font-semibold text-gray-900" +
              (exists
                ? " text-ula-secondary border-ula-blue bg-blue-100 "
                : " border-gray-300 ") +
              (index === items.length - 1
                ? " rounded-r-md "
                : " border-b border-l border-r-0 border-t   ")
            }
          >
            {item.value}
          </div>
        );
      })}

      {/* <div className="  flex-shrink-0 cursor-pointer items-center  justify-center    px-5 py-2 font-semibold text-gray-900">
      5
    </div> */}
    </div>
  );
}

export default BedMobileRefinement;
